<template>
  <div></div>
</template>

<script>
const iamportUrl = 'https://cdn.iamport.kr/js/iamport.payment-1.1.8.js'

// 이앨리스 imp97437955
// 학지사캠퍼스북 imp68757004
const iamportMerchId = 'imp68757004'
// window.location.host.indexOf('www-qa') >= 0 ? 'imp97437955' : 'imp68757004'

export default {
  mounted() {
    if (window.IMP === undefined) {
      this.loadIamport()
    }
  },
  methods: {
    loadIamport() {
      //Load jQuery
      const jqueryScript = document.createElement('script')
      jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js'
      jqueryScript.onload = () => {
        //Load Iamport
        const script = document.createElement('script')
        script.src = iamportUrl
        script.onload = () => {
          window.IMP.init(iamportMerchId)
        }
        document.getElementsByTagName('head')[0].appendChild(script)
      }
      document.getElementsByTagName('head')[0].appendChild(jqueryScript)
    }
  }
}
</script>

<style lang="scss" scoped></style>
